module.exports = __webpack_public_path__ + "img/down.966c733c.svg";